<template>
  <template-info
    :bgImg="bgImg"
    title="เปลี่ยนจากบุคคลธรรมดาเป็นนิติบุคคลต้องทำอะไรบ้าง"
  >
    <div>
      <div class="wrap-number-li">
        <span> 1. </span>
        <span class="contents">
          <span class="bold"
            >เปิดบัญชีเงินฝากธนาคารในนามบริษัทหรือห้างหุ้นส่วนนิติบุคคล</span
          >
          เพื่อใช้เป็นบัญชีหลักในการทำ
          ธุรกรรมทางการเงินทุกรายการที่เกี่ยวข้องกับ กิจการ
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 2. </span>
        <span class="contents"
          ><span class="bold">บิลซื้อ-บิลขาย</span>
          ซื้อวัตถุดิบเพื่อใช้ผลิตสินค้าหรือ บริการ
          หรือจ่ายค่าใช้จ่ายที่เกี่ยวข้องกับกิจการ
          ต้องขอบิลทุกครั้งและรายละเอียดในบิลต้อง ถูกต้องครบถ้วน
          กรณีมีรายการขายสินค้าหรือ รับเงินค่าบริการก็ต้องมีการออกใบเสร็จรับเงิน
          ให้ถูกต้อง
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 3. </span>
        <span class="contents">
          <span class="bold">ภาษีมูลค่าเพิ่ม</span>
          กรณีเป็นผู้ประกอบการจดทะเบียน ภาษีมูลค่าเพิ่ม
          ต้องออกใบกำกับภาษีขายเมื่อมีการ ขายสินค้าหรือให้บริการ
          (และขอใบกำกับภาษีซื้อ เมื่อมีการซื้อสินค้าหรือรับบริการ)
          ซึ่งใบกำกับภาษี ต้องมีรายการถูกต้อง ครบถ้วน นอกจากนี้
          ผู้ประกอบการต้องยื่นแบบแสดงรายการภาษี มูลค่าเพิ่มเป็นประจำทุกเดือน
          ไม่ว่าเดือน นั้นจะมี ยอดซื้อ/ยอดขายหรือไม่ก็ตาม
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 4. </span>
        <span class="contents">
          <span class="bold">ภาษีหัก ณ ที่จ่าย</span>
          เป็นหน้าที่ที่กฎหมายกำหนดให้ ต้องหักและนำส่งกรมสรรพากร
        </span>
      </div>
      <div class="wrap-number-li">
        <span> 5. </span>
        <span class="contents">
          <span class="bold">นำส่งเอกสารประกอบการลงบัญชี</span>
          ไม่ว่าจะเป็น บิลซื้อ-บิลขาย ใบกำกับภาษีซื้อ ใบกำกับภาษีขาย
          หนังสือรับรองการหักภาษี ณ ที่จ่าย เจ้าของกิจการ
          ต้องรวบรวมและสรุปนำส่งให้สำนักงานบัญชีเพื่อ
          นำไปดำเนินการลงบัญชีและปิดบัญชีตามรอบเวลา
        </span>
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/change_process.png";

export default {
  name: "ChangeProcess",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {},
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
.wrap-knowledge {
  margin-top: 32px;
}
.wivb-contents {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 23px;
  font-size: 17px;
  margin-bottom: 0px;
  color: #393d43;
}
.title {
  margin-bottom: 8px;
}
.wrap-number-li {
  display: flex;
  margin-top: 15px;
}
.wrap-number-li :first-child {
  min-width: 26px;
}
.red {
  color: #f45a49;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .wrap-knowledge:last-child {
    margin-top: 0;
  }
}
</style>
